module.exports = __webpack_public_path__ + "static/banner-mobile-060d5e157fa7cabf9e3d45bf11671cb7.png";